import Swal from 'sweetalert2';
import { url } from '../api/api';
import { NUMROWINVOICESTATEORDERLINE, ROLADMIN, ROLCOLABORADOR, ROLREVENDEDOR, ROLVENDEDOR } from '../utils/constants';
import { loadJWT } from './loadJWT';
import dateFormat from 'dateformat';
import axios from 'axios';

export const loadLines = async (page, rol, loggedInUser, dateRange) => {
  let lines = [];
  const { token } = loadJWT();
  let total = 0;
  let sumTotalAux = 0;
  let sumInSituEuros = 0;
  let sumReservaEuros = 0;
  let sumDescuentoEuros = 0;
  let sumReventaEuros = 0;
  let sumBalanceDolares = 0;

  const query =
    rol === ROLADMIN || rol === ROLCOLABORADOR
      ? `/lineas-ventas?filter={"where": {"FechaRecogida": {"between": ["${dateFormat(
          dateRange[0],
          'isoUtcDateTime',
        )}", "${dateFormat(
          dateRange[1],
          'isoUtcDateTime',
        )}"]}},"include": [{"relation": "Venta", "scope":{"include": [{"relation": "Cliente"}, {"relation": "Usuario"}]}}, {"relation": "ServicioProveedor"}, {"relation": "Proveedor"}], "skip": ${
          page * NUMROWINVOICESTATEORDERLINE
        }, "limit": ${NUMROWINVOICESTATEORDERLINE}}`
      : (rol === ROLVENDEDOR || rol === ROLREVENDEDOR) &&
        `/lineas-ventas?filter={"where": {"FechaRecogida": {"between": ["${dateFormat(
          dateRange[0],
          'isoUtcDateTime',
        )}", "${dateFormat(
          dateRange[1],
          'isoUtcDateTime',
        )}"]}, "FkUsuarios": ${loggedInUser}},"include": [{"relation": "Venta", "scope":{"include": [{"relation": "Cliente"}, {"relation": "Usuario"}]}}, {"relation": "ServicioProveedor"}, {"relation": "Proveedor"}], "skip": ${
          page * NUMROWINVOICESTATEORDERLINE
        }, "limit": ${NUMROWINVOICESTATEORDERLINE}}`;
  const queryCount =
    rol === ROLADMIN || rol === ROLCOLABORADOR
      ? `/lineas-ventas/count?filter={"where": {"FechaRecogida": {"between": ["${dateFormat(
          dateRange[0],
          'isoUtcDateTime',
        )}", "${dateFormat(
          dateRange[1],
          'isoUtcDateTime',
        )}"]}},"include": [{"relation": "Venta", "scope":{"include": [{"relation": "Cliente"}, {"relation": "Usuario"}]}}, {"relation": "ServicioProveedor"}, {"relation": "Proveedor"}], "skip": ${
          page * NUMROWINVOICESTATEORDERLINE
        }, "limit": ${NUMROWINVOICESTATEORDERLINE}}`
      : (rol === ROLVENDEDOR || rol === ROLREVENDEDOR) &&
        `/lineas-ventas/count?filter={"where": {"FechaRecogida": {"between": ["${dateFormat(
          dateRange[0],
          'isoUtcDateTime',
        )}", "${dateFormat(
          dateRange[1],
          'isoUtcDateTime',
        )}"]}, "FkUsuarios": ${loggedInUser}},"include": [{"relation": "Venta", "scope":{"include": [{"relation": "Cliente"}, {"relation": "Usuario"}]}}, {"relation": "ServicioProveedor"}, {"relation": "Proveedor"}], "skip": ${
          page * NUMROWINVOICESTATEORDERLINE
        }, "limit": ${NUMROWINVOICESTATEORDERLINE}}`;

  const sumTotal = `/lineas-ventas/sum?filter={"where": {"FechaRecogida": {"between": ["${dateFormat(
    dateRange[0],
    'isoUtcDateTime',
  )}", "${dateFormat(
    dateRange[1],
    'isoUtcDateTime',
  )}"]}},"include": [{"relation": "Venta", "scope":{"include": [{"relation": "Cliente"}, {"relation": "Usuario"}]}}, {"relation": "ServicioProveedor"}, {"relation": "Proveedor"}]}`;

  const linesQuery = url.get(`${query}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const countQuery = url.get(`${queryCount}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const sumQuery = url.get(`${sumTotal}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  await axios
    .all([linesQuery, countQuery, sumQuery])
    .then(([res1, res2, res3]) => {
      if (res1.data) {
        lines = res1.data.map(resp => resp);
      }
      total = res2.data.count;
      sumTotalAux = res3.data.sum;
      sumInSituEuros = res3.data.sumInSituEuros;
      sumReservaEuros = res3.data.sumReservaEuros;
      sumDescuentoEuros = res3.data.sumDescuentoEuros;
      sumReventaEuros = res3.data.sumReventaEuros;
      sumBalanceDolares = res3.data.sumBalanceDolares;
    })

    .catch(e => {
      Swal.fire('Error', e?.response?.data?.error?.message || 'Error. Contacte con el administrador', 'error');
    });
  return [
    lines,
    total,
    sumTotalAux,
    sumInSituEuros,
    sumReservaEuros,
    sumDescuentoEuros,
    sumReventaEuros,
    sumBalanceDolares,
  ];
};
